module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.occurrences) ? _c('article', {
    staticClass: "tile is-child box"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Tickets "), (_vm.internal) ? _c('span', [_vm._v("Internal")]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-narrow"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.occurrences), function(occurrence) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(occurrence.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(occurrence.subject))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.parseDepartament(occurrence.departament)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(occurrence.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(occurrence.user))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.parseStatus(occurrence.status)))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_c('tooltip', {
      attrs: {
        "label": "View",
        "type": "default",
        "placement": "left"
      }
    }, [_c('a', {
      staticClass: "button button-table is-small",
      on: {
        "click": function($event) {
          return _vm.url(occurrence.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })])])], 1)])
  }), 0)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "is-primary"
  }, [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Subject")]), _vm._v(" "), _c('th', [_vm._v("Department")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("User")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-397fe3b3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/occurrences/OccurrencesSimple.vue
// module id = 1111
// module chunks = 39